import Link from 'next/link';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import { RelatedSectionDTO } from '@lib/strapi/dtos/components/sections/relatedSection.dto';

/**
 * The condition↔treatment cross-links (item 18), read from the entity the
 * union route resolved — the relation is maintained once, on the entries, so
 * the two directions cannot disagree. With flat root URLs (item 9) these links
 * carry real SEO weight: they are much of what tells a crawler how the pages
 * relate.
 */
const RelatedSectionImplementation = ({ section, page }: ComponentProps<RelatedSectionDTO>) => {
  if (!section) return null;
  const entity = (page as { entity?: { treatments?: unknown[]; conditions?: unknown[] } } | undefined)?.entity;
  const list = ((section.direction === 'TreatmentsForCondition' ? entity?.treatments : entity?.conditions) ?? []) as {
    slug?: string; title?: string;
  }[];
  if (!list.length) return null;

  return (
    <section className="my-8">
      {section.heading ? <h2 className="mb-4 text-xl font-extrabold text-ink">{section.heading}</h2> : null}
      <div className="flex flex-wrap gap-2.5">
        {list.map((e) => (
          <Link key={e.slug} href={`/${e.slug}`}
            className="rounded-full border border-violet-200 bg-violet-050 px-4 py-2 text-sm font-bold text-violet-700 transition-colors hover:border-violet-700 hover:bg-violet-200">
            {e.title}
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedSectionImplementation;
